import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";

const smartTagSchema = z.object({
  tag_value: z.string().min(1, "Tag value is required"),
});

type SmartTagFormProps = {
  onSubmit: (values: z.infer<typeof smartTagSchema>) => void;
};

export const SmartTagForm = ({ onSubmit }: SmartTagFormProps) => {
  const form = useForm<z.infer<typeof smartTagSchema>>({
    resolver: zodResolver(smartTagSchema),
    defaultValues: {
      tag_value: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="tag_value"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Tag Value</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Enter alternative term" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit">Add Tag</Button>
      </form>
    </Form>
  );
};
